import {NgModule} from '@angular/core';
import {BrowserModule, Title} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatSliderModule} from '@angular/material/slider';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCommonModule} from '@angular/material/core';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTableModule} from '@angular/material/table';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {HttpInterceptorService} from "./services/interceptors/HttpInterceptorService";
import {ToastrModule} from 'ngx-toastr';
import {LocationStrategy, PathLocationStrategy} from "@angular/common";
import {SortDirective} from "./helpers/sort/sort.directive";
import {FilterListPipe} from "./helpers/pipes/filter-list-by-bib.pipe";
import {ParticipantsComponent} from "./components/participants/participants.component";
import {EventsComponent} from './components/events/events.component';
import {TagBibComponent} from './components/tag-bib/tag-bib.component';
import {LogsComponent} from './components/logs/logs.component';
import {AutofocusDirective} from "./helpers/AutofocusDirective";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {ScrollingModule} from '@angular/cdk/scrolling';
import {MassAssignmentComponent} from './components/mass-assignment/mass-assignment.component';
import {BurgerMenuComponent} from './components/burger-menu/burger-menu.component';
import {FilterTeamsByBibPipe} from "./helpers/pipes/filter-teams-by-bib.pipe";
import {UsersComponent} from "./components/users/users.component";
import {MaskTokenPipe} from "./helpers/pipes/mask-token.pipe";
import {OfflineQueueInterceptor} from "./services/interceptors/OfflineQueueInterceptor";
import {VirtualListDemoComponent} from "./components/participants/virtual-list-demo.component";

@NgModule({
  declarations: [
    AppComponent,
    ParticipantsComponent,
    SortDirective,
    FilterListPipe,
    MaskTokenPipe,
    FilterTeamsByBibPipe,
    AutofocusDirective,
    EventsComponent,
    UsersComponent,
    TagBibComponent,
    LogsComponent,
    MassAssignmentComponent,
    BurgerMenuComponent,
    VirtualListDemoComponent
  ],
  imports: [
    BrowserModule,
    MatSliderModule,
    MatSidenavModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatSliderModule,
    MatCommonModule,
    MatFormFieldModule,
    MatTableModule,
    MatPaginatorModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    MatProgressBarModule,
    ScrollingModule,
    ReactiveFormsModule,
    NgbModule,
    FormsModule,
    ToastrModule.forRoot(
      {
        timeOut: 2500,
        positionClass: 'toast-top-right'
      }
    ),
    MatProgressBarModule
  ],
  providers: [
    Title,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OfflineQueueInterceptor,
      multi: true
    },
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
